import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

// import Button           from '@material-ui/core/Button'

import CircularProgress from '@material-ui/core/CircularProgress'
import Grid             from '@material-ui/core/Grid'
import Hidden           from '@material-ui/core/Hidden'
import DeleteIcon       from '@material-ui/icons/Delete'
import FileDownloadIcon from '@material-ui/icons/FileDownload'

import { isAdmin }                            from '../../project-utils/permissions'
import { Back, ClickPrompt, PermissionGuard, Button } from '../atoms'
import DownloadExport                         from '../organisms/DownloadExport'

const ProcessBar = ({
  deleteProcess,
  deleteFetching,
  exportRequest,
}) => {
  const phrasing = {
    download:                 <FormattedMessage id={'buttonActions.download'} />,
    deleteProcessPrompt:      <FormattedMessage id={'generic.deleteProcessPrompt'} />,
    thisActionCannotBeUndone: <FormattedMessage id={'generic.thisActionCannotBeUndone'} />,
  }

  const deleteButtonContent =
    deleteFetching
      ? <CircularProgress size={20} />
      : (
        <>
          <Hidden xsDown>
            <DeleteIcon style={{ marginRight: 8 }} />
            <FormattedMessage id={'buttonActions.delete'} />
          </Hidden>
          <Hidden smUp>
            <DeleteIcon />
          </Hidden>
        </>
      )

  return (
    <Grid
      container
      justify={'space-between'}
      alignItems={'center'}
    >
      <Grid item>
        <Back />
      </Grid>
      <PermissionGuard check={isAdmin}>
        <Grid item>
          <Grid container spacing={16}>
            <Grid item>
              <DownloadExport
                fileName={'process.xlsx'}
                fileRequest={exportRequest}
              >
                {({ loaded }) => (
                  <Button
                    disabled={!loaded}
                    color={'secondary'}
                    variant={'raised'}
                  >
                    <Hidden xsDown>
                      <FileDownloadIcon style={{ marginRight: 8 }} />
                      {phrasing.download}
                    </Hidden>
                    <Hidden smUp>
                      <FileDownloadIcon />
                    </Hidden>
                  </Button>
                )}
              </DownloadExport>
            </Grid>
            <Grid item>
              <ClickPrompt
                header={phrasing.deleteProcessPrompt}
                subheader={phrasing.thisActionCannotBeUndone}
              >
                <Button
                  variant={'raised'}
                  onClick={deleteProcess}
                  color={'primary'}
                >
                  {deleteButtonContent}
                </Button>
              </ClickPrompt>
            </Grid>
          </Grid>
        </Grid>
      </PermissionGuard>
    </Grid>
  )
}

export default ProcessBar



// WEBPACK FOOTER //
// ./src/components/molecules/ProcessBar.tsx